import { HttpStatusCode } from '@angular/common/http';

import { createAction, props, union } from '@ngrx/store';

import { ReferenceType, ReferenceTypeIdentifier } from '@cdba/shared/models';

export const selectReferenceTypeIdentifier = createAction(
  '[Detail] Select Reference Type Identifier',
  props<{ referenceTypeIdentifier: ReferenceTypeIdentifier }>()
);

export const loadProductDetails = createAction('[Detail] Load Product Details');

export const loadProductDetailsSuccess = createAction(
  '[Detail] Load Product Details Success',
  props<{ referenceType: ReferenceType }>()
);

export const loadProductDetailsFailure = createAction(
  '[Detail] Load Product Details Failure',
  props<{ errorMessage: string; statusCode: HttpStatusCode }>()
);

const _all = union({
  selectReferenceTypeIdentifier,
  loadProductDetails,
  loadProductDetailsSuccess,
  loadProductDetailsFailure,
});

export type ProductDetailsActions = typeof _all;
